<template>
	<div>
		<RadioGroup
			v-model="yesNo"
			:options="yesNoOptions"
			@change="emitChangeEvent"
		/>
		<div
			v-if="sleepoverEligible"
			class="mt-3"
		>
			<Messages :messages="['Wieviele Übernachtungen wären für dich OK?']" />
			<SelectInline
				v-model="sleepover"
				:characteristic-items="meta.externalSleepover"
				:nothing-allowed="{
					text: 'egal'
				}"
				@input="emitChangeEvent"
			/>
		</div>
	</div>
</template>
<script>
import {isDefined} from "@/helper/Value";
import SingleSelect from "@/vue/characteristic/SingleSelect";
import {APPLICATION} from "@/helper/characteristic/Label";
import {mapState} from "vuex";
import SelectInline from "@/vue/characteristic/SelectInline";
import Messages from "@/vue/common/slide-in/Messages";
import RadioGroup from "@/vue/common/form/RadioGroup";

export default {

	components: {
		RadioGroup,
		SelectInline,
		SingleSelect,
		Messages,
	},

	props: {
		value: {
			type: Object,
			required: false,
		},
	},

	data ()
	{
		return {
			display: this.initialDisplay,
			yesNo: this.value?.yesNo,
			yesNoOptions: Object.freeze([
				{value: false, text: 'Nein, für mich kommen gar keine externen Übernachtungen in Frage'},
				{value: true, text: 'Ja, externe Übernachtungen sind in Ordnung'},
			]),
			sleepover: this.value?.sleepover,
			labelTypeApplication: APPLICATION,
		};
	},

	computed: {
		...mapState('meta', [ 'meta' ]),
		yesNoValid ()
		{
			return isDefined(this.yesNo);
		},
		sleepoverEligible ()
		{
			return this.yesNo === true;
		},
		sleepoverValid ()
		{
			return !this.sleepoverEligible || this.sleepover !== undefined;
		},
		dataValid ()
		{
			return this.yesNoValid
				&& this.sleepoverValid;
		},
	},

	methods: {
		emitChangeEvent ()
		{
			if (!this.dataValid)
			{
				this.$emit('input', undefined);
				return;
			}

			this.$emit('input', {
				yesNo: this.yesNo,
				sleepover: this.sleepoverEligible
					? this.sleepover
					: undefined,
			});
		}
	}
}
</script>
